import { createAppByPlatform } from '@/create-app/createAppIs24';
import { createAuth0Instance } from '@/helpers/Auth/authClient';
import { initDatadogRUM } from '@/helpers/RUMService/RUMService';
import { AppState } from '@/store/types';
import App from './AppIs24.vue';
import scrollIntoView from './directives/scrollIntoView';

import('@smg-real-estate/acr-injection/umd');

(async () => {
  const { app, router, store } = await createAppByPlatform(App);

  app.directive('scroll-into-view', scrollIntoView);

  initDatadogRUM();

  const initialState = window.__INITIAL_STATE__ as AppState;
  if (initialState) {
    store.replaceState(initialState);
  }

  const auth0 = createAuth0Instance();
  if (auth0) {
    app.use(auth0 as any);
  }

  await router.isReady();
  app.mount('#app');
})();
